export const iconFontAwesomeBuildingsSchool = (
	<i className="fa-solid fa-school"></i>
);
